import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { TicketCharacters } from '../../../../common/enums'

@Component
class TicketCondition extends Vue {
  dtShowMore: boolean;
  dtNatureOfProblems: {
    value: number;
    icon?: string;
    translation?: string;
  }[]

  @Prop({ default: () => [], type: [Array] })
  source: any[]

  /**
   *
   */
  constructor () {
    super()
    this.dtShowMore = false
    this.dtNatureOfProblems = [
      { value: TicketCharacters.Plumbing, icon: 'icon-plumbing-small' },
      { value: TicketCharacters.Electricity, icon: 'icon-electricity-small' },
      { value: TicketCharacters.HomeAppliance, icon: 'icon-householdappliance-small' },
      { value: TicketCharacters.Heating, icon: 'icon-heating-small' },
      { value: TicketCharacters.Glaziery, icon: 'icon-glaziery-small' },
      { value: TicketCharacters.Other, icon: 'icon-other-small' }
    ]
  }
  @Prop({
    default: null,
    type: [Number]
  })
  value: number | null;

  get lblSetting () {
    return {
      ...require('../../../../locales/ticket').default,
      ...require('../../../../locales/generic-labels').default
    }
  }
  get vModel (): number { return this.value }
  set vModel (value: number) {
    this.$emit('input', value)
  }

  get coSource () {
    // keep the order of API to get display by name
    return this.source/* _.orderBy(this.source, ['id', 'asc']) */
  }

  getActivedColor (value: number) {
    return value === this.vModel ? 'secondary' : 'primary'
  }

  _clearTimeout: any;
  handleAssignModel (value: number) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.vModel = value
      this.$emit('onChange', value)
    }, 100)
  }

  getTranslationByValue (value: number) {
    return this.$t(this.lblSetting[`ticketCharacterProblem${value}`])
  }
  get height (): any {
    if (this.dtShowMore) {
      return { height: 'auto' }
    } else {
      return { height: '220px' }
    }
  }
  handleShowMore () {
    this.dtShowMore = !this.dtShowMore
  }
  mounted () {
    this.dtNatureOfProblems = this.coSource
    this.$watch('source', (n, o) => this.dtNatureOfProblems = n)
  }
}

export default TicketCondition



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-nature-of-problem/index.ts